export interface OTPRequiredResponse {
  otpRequired: boolean
  customerEmail: string
  customerId: number
}
